// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__FhTbH","text":"text__3GVyv","date":"date__1_YmG","button-wrapper":"button-wrapper__1u2W8"};